import { Center, Text } from "@chakra-ui/react"

const EmptyState = ({ text, children }) => (
  <Center p={8} d="flex" flexDirection="column">
    <Text as="strong" mb={4}>
      {text}
    </Text>
    {children}
  </Center>
)
export default EmptyState
